const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID || "2049327962391773";

// Plan values (USD) for InitiateCheckout / Purchase attribution
const PLAN_VALUES = {
  premium_monthly: 9.99,
  premium_annual: 49.99,
};

// Stripe price IDs -> plan IDs (mirrors STRIPE_PRODUCTS in services/subscription.js)
const STRIPE_PRICE_TO_PLAN = {
  price_1TGuUXLEwMxFpWxPrjY2OZMd: "premium_monthly",
  price_1TRsX0LEwMxFpWxPz9lWy2XG: "premium_monthly",
  price_1SVmpZLEwMxFpWxPy5ZeYoyy: "premium_monthly",
  price_1TGuhnLEwMxFpWxPiKl5fWUm: "premium_annual",
  price_1UIHHfLEwMxFpWxPkT9Y7dO3: "premium_annual",
};

let initialized = false;

export const initMetaPixel = () => {
  if (initialized || !PIXEL_ID || typeof window === "undefined") return;
  initialized = true;

  const fbq = function (...args) {
    if (fbq.callMethod) {
      fbq.callMethod(...args);
    } else {
      fbq.queue.push(args);
    }
  };
  window.fbq = window.fbq || fbq;
  window._fbq = window._fbq || window.fbq;
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = "2.0";
  fbq.queue = [];

  const script = document.createElement("script");
  script.async = true;
  script.src = "https://connect.facebook.net/en_US/fbevents.js";
  const firstScript = document.getElementsByTagName("script")[0];
  firstScript.parentNode.insertBefore(script, firstScript);

  window.fbq("init", PIXEL_ID);
};

export const trackPixelPageView = () => {
  if (window.fbq) window.fbq("track", "PageView");
};

export const trackPixelStandardEvent = (eventName, params = {}, eventID) => {
  if (!window.fbq) return;
  if (eventID) {
    window.fbq("track", eventName, params, { eventID });
  } else {
    window.fbq("track", eventName, params);
  }
};

export const trackInitiateCheckout = (planId) => {
  const params = { content_name: planId, currency: "USD" };
  if (PLAN_VALUES[planId] !== undefined) {
    params.value = PLAN_VALUES[planId];
    params.content_ids = [planId];
  }
  trackPixelStandardEvent("InitiateCheckout", params);
};

export const trackPurchase = (priceId, eventID) => {
  const planId = STRIPE_PRICE_TO_PLAN[priceId];
  const params = { currency: "USD", content_name: planId || "subscription" };
  if (planId) {
    params.value = PLAN_VALUES[planId];
    params.content_ids = [planId];
  }
  trackPixelStandardEvent("Purchase", params, eventID);
};

export const trackPixelCustomEvent = (eventName, params = {}) => {
  if (window.fbq) window.fbq("trackCustom", eventName, params);
};
